import * as amplitude from '@amplitude/unified'

const API_KEY = process.env.GATSBY_AMPLITUDE_API_KEY
const isBrowser = typeof window !== 'undefined'

export const initAmplitude = () => {
  if (!isBrowser || !API_KEY) {
    console.warn('[Amplitude] GATSBY_AMPLITUDE_API_KEY is not set. Analytics disabled.')
    return false
  }

  amplitude.initAll(API_KEY, {
    serverZone: 'EU',
    analytics: {
      autocapture: {
        attribution: true,
        pageViews: true,
        sessions: true,
        fileDownloads: true,
        formInteractions: true,
        elementInteractions: true
      }
    }
  })

  return true
}

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content']

const extractUtmParams = (search) => {
  if (!search) return {}
  const params = new URLSearchParams(search)
  return UTM_KEYS.reduce((acc, key) => {
    const value = params.get(key)
    if (value) acc[key] = value
    return acc
  }, {})
}

export const trackPageView = (path, search) => {
  if (!isBrowser || !API_KEY) return
  amplitude.track('Page Viewed', {path, ...extractUtmParams(search)})
}

export const trackEvent = (eventName, eventProperties = {}) => {
  if (!isBrowser || !API_KEY) return
  amplitude.track(eventName, eventProperties)
}

export const identifyUser = (userId) => {
  if (!isBrowser || !API_KEY) return
  amplitude.setUserId(userId)
}
